import { defineStore } from 'pinia'

export const useDateStore = defineStore('date', {
  state: () => ({
    selectedDate: null,
  }),
  actions: {
    setDate(date) {
      this.selectedDate = date
    }
  }
})
